<script setup>
const props = defineProps({
  item1: Object,
  item2: Object,
  item3: Object,
  activeId: [Number, String],
});
</script>

<template>
  <div class="w-full md:w-1/2 flex">
    <div class="relative w-full md:pt-100p">
      <div class="md:absolute md:inset-0 w-full md:h-full flex flex-wrap">
        <!-- activeID = {{ activeId }} <br />itemID = {{ item1?.id }} -->
        <Tile
          size="2x1"
          :type="item1?.type ?? null"
          :detail="item1?.detail ?? null"
          :title="item1?.title ?? null"
          :subtitle="item1?.subtitle ?? null"
          :url="item1?.url ?? null"
          :slug="item1?.slug ?? null"
          :image="item1?.image ?? null"
          :video="item1?.video ?? null"
          :fade="item1?.fade ?? false"
          :bgColor="item1?.bgColor ?? null"
          :active="activeId !== '' && activeId === item1?.id"
          :class="item1.hasContent ? '' : 'tile--empty'"
        />
        <!-- activeID = {{ activeId }} <br />itemID = {{ item2?.id }} -->
        <Tile
          size="1x1"
          :type="item2?.type ?? null"
          :detail="item2?.detail ?? null"
          :title="item2?.title ?? null"
          :subtitle="item2?.subtitle ?? null"
          :url="item2?.url ?? null"
          :slug="item2?.slug ?? null"
          :image="item2?.image ?? null"
          :video="item2?.video ?? null"
          :fade="item2?.fade ?? false"
          :bgColor="item2?.bgColor ?? null"
          :active="activeId !== '' && activeId === item2?.id"
          :class="item2.hasContent ? '' : 'tile--empty'"
        />
        <!-- activeID = {{ activeId }} <br />itemID = {{ item3?.id }} -->

        <Tile
          size="1x1"
          :type="item3?.type ?? null"
          :detail="item3?.detail ?? null"
          :title="item3?.title ?? null"
          :subtitle="item3?.subtitle ?? null"
          :url="item3?.url ?? null"
          :slug="item3?.slug ?? null"
          :image="item3?.image ?? null"
          :video="item3?.video ?? null"
          :fade="item3?.fade ?? false"
          :bgColor="item3?.bgColor ?? null"
          :active="activeId !== '' && activeId === item3?.id"
          :class="item3.hasContent ? '' : 'tile--empty'"
        />
      </div>
    </div>
  </div>
</template>
